import type {EmbeddingParamsRequest} from 'src/features/erp-sutor/features/analytics/types';

export class AnalyticsService {
    public static serviceName = 'analyticsService';

    private static readonly EMBEDDED_DASHBOARD_ROUTE = 'analytics/embedded/dashboard';
    private static readonly EMBEDDED_CHART_ROUTE = 'analytics/embedded/chart';

    public getEmbeddedDashboardUrl(dashboardId: string, params: EmbeddingParamsRequest): string {
        const paramsRecord: Record<string, string> = {
            record: params.record,
            ...Object.fromEntries(params.params.map((p) => [p.name, p.valueType]))
        };

        const queryString = new URLSearchParams(paramsRecord).toString();

        return `${(AnalyticsService.EMBEDDED_DASHBOARD_ROUTE)}/${dashboardId}?${queryString}`;
    }

    public getEmbeddedChartUrl(chartId: string, params: EmbeddingParamsRequest): string {
        const paramsRecord: Record<string, string> = {
            record: params.record,
            ...Object.fromEntries(params.params.map((p) => [p.name, p.valueType]))
        };


        const queryString = new URLSearchParams(paramsRecord).toString();

        return `${(AnalyticsService.EMBEDDED_CHART_ROUTE)}/${chartId}?${queryString}`;
    }
}